// Display helpers shared by every subscription / wallet / reward screen.
// Formatting only — amounts are always shown exactly as the backend sends
// them, never re-calculated here (guide rule: no money maths on the UI).
import { format } from "date-fns";

const isBlank = (value) => value === null || value === undefined || value === "";

// Guide rule: wallet, days left and points are never shown below 0. The
// backend already clamps them; this is only the frontend safety net.
// Blank / non-numeric values pass through untouched (they still show "-").
export const atLeastZero = (value) => {
  if (isBlank(value)) return value;
  const num = Number(value);
  return Number.isNaN(num) ? value : Math.max(0, num);
};

export const formatINR = (value) => {
  if (isBlank(value)) return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return "-";
  return num.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  });
};

export const formatPoints = (value) => {
  if (isBlank(value)) return "-";
  const num = Number(value);
  return Number.isNaN(num) ? "-" : num.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

export const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : format(date, "dd-MMM-yyyy");
};

export const monthYearLabel = (month, year) => {
  const m = Number(month);
  const y = Number(year);
  if (!m || !y || m < 1 || m > 12) return "-";
  return format(new Date(y, m - 1, 1), "MMM yyyy");
};

// Backend flags come as 1/0, true/false or "1"/"true" depending on the SP.
export const isTruthyFlag = (value) =>
  value === true || value === 1 || value === "1" || String(value).toLowerCase() === "true";

// ---------------------------------------------------------------- dates
// "2026-11" -> { month: 11, year: 2026 }
export const splitPeriod = (period) => {
  const [year, month] = String(period || "").split("-").map(Number);
  return { month: month || undefined, year: year || undefined };
};
